import { render, staticRenderFns } from "./TableLeaseAgreementsExpiring.vue?vue&type=template&id=39dd6f8a&"
import script from "./TableLeaseAgreementsExpiring.vue?vue&type=script&lang=js&"
export * from "./TableLeaseAgreementsExpiring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports